// eslint-disable-next-line import/prefer-default-export
export const getShouldRePlacementModalBeShown = (placement, savedPlacement, placedMethod) =>
  !!savedPlacement && savedPlacement !== placement && placedMethod === 'manual';
